export default "__VITE_ASSET__Cd6QIz$m__"